//const LOCAL_URL = "localhost:3007/api/v1/";
// const BASE_URL =
//   '${process.env.REACT_APP_API_URL}'; //--For all
const BASE_URL = process.env.REACT_APP_API_URL; //--For all
const BASE_URL_NEW = process.env.REACT_APP_API_NEW_URL;

const BASE_URL_NEW_TICKET = process.env.REACT_APP_API_NEW_URL_TICKET;

export const RoomBookingAllGraphs = {
  // data: "http://staging-meeting.sworks.co.in/Application/Api/graph", //post
  data: BASE_URL + 'user/meetingroom_graph',
};

export const getAllLofoList = BASE_URL + 'basic-data/get-client-logo';

export const getLogoUserCompanyId = BASE_URL + 'basic-data/get-client-logo-by-companyid';

export const listRemove = {
  // data: "https://portal.smartworksoffice.com/Application/Apiapp/deleteseatapi", //post
  data: BASE_URL + 'user/deleteSeat',
};

export const invoiceUrl = {
  // data: "https://portal.smartworksoffice.com/Application/Apiapp/deleteseatapi", //post
  data: BASE_URL + 'user/invoice_list',
};

export const invoiceUrlNew = {
  // data: "https://portal.smartworksoffice.com/Application/Apiapp/deleteseatapi", //post
  data: BASE_URL + 'user/invoiceGraph',
};

// export const invoiceUrlNew = {
//   // data: "https://portal.smartworksoffice.com/Application/Apiapp/deleteseatapi", //post
//   data: BASE_URL + 'user/invoiceGraph',
// };

export const ComplianceLeagleUrl = {
  // data: "https://portal.smartworksoffice.com/Application/Apiapp/deleteseatapi", //post
  data: BASE_URL + 'user/complianceAndLegal',
};
export const ComplianceDocumentUrl = {
  // data: "https://portal.smartworksoffice.com/Application/Apiapp/deleteseatapi", //post
  data: BASE_URL + 'user/company_document',
};
export const ComplianceFileUrl = {
  // data: "https://portal.smartworksoffice.com/Application/Apiapp/deleteseatapi", //post
  data: BASE_URL + 'user/upload_doc',
};

export const LocationFilter = {
  // data:
  //   "http://staging-cms.sworks.co.in/Application/clientspoc/getallcenters", //post
  data: BASE_URL + 'basic-data/get-location-by-spoc',
};

export const EditRoomTrainingAdd = {
  // data: "http://staging-meeting.sworks.co.in/Application/Api/editroomdetails", //post
  data: BASE_URL_NEW + 'api/resource',
};

export const RoomTrainingAdd = {
  // data: "http://staging-meeting.sworks.co.in/Application/Api/addroom", //post
  data: BASE_URL_NEW + 'api/resource',
};



export const cityFilterUrl = {
  // data: "http://staging-meeting.sworks.co.in/Application/Api/cityapi", //city-filter-roomtraining
  data: BASE_URL + 'user/city_list',


  
};
export const buildingFilterUrl = {
  // data: "http://staging-meeting.sworks.co.in/Application/Api/buildingapi", //city-filter-roomtraining
  data: BASE_URL + 'user/building_list',
};
export const TowerFilterUrl = {
  // data: "http://staging-meeting.sworks.co.in/Application/Api/towerapi", //city-filter-roomtraining
  data: BASE_URL + 'user/tower_list',
};

export const FloorFilterUrl = {
  // data: "http://staging-meeting.sworks.co.in/Application/Api/floorapi", //city-filter-roomtraining
  data: BASE_URL + 'user/floor_list',
};

export const TicktingList = {
  // List: "http://staging-cms.sworks.co.in/Application/Clientspoc/ticketlist", //post
  List: BASE_URL_NEW_TICKET + 'ticketListV3',
};

export const login = {
  login: BASE_URL + 'user/spoc_login', //post
};

export const loginMail = {
  email: BASE_URL + 'user/spoc_emailVerify', //post
};

export const spocMemberList = {
  memberList: BASE_URL + 'user/member_list_by_locationv2', //GET
};

export const exportFile = {
  // memberList: "http://staging-cms.sworks.co.in/Application/Clientspoc/downloadmemberlist", //GET
  memberList: BASE_URL + 'user/downloadmember_list',
};

export const aditionalmember = {
  // data: "http://staging-cms.sworks.co.in/Application/Clientspoc/cityapi", //GET City Data For All
  data: BASE_URL + 'user/city',
};

export const cityUrl = {
  // data: "http://staging-cms.sworks.co.in/Application/Clientspoc/buildingapi", //post city data All
  data: BASE_URL + 'user/building',
};

export const buildingUrl = {
  // data: "http://staging-cms.sworks.co.in/Application/Clientspoc/floorapi", //post city data All
  data: BASE_URL + 'user/floor',
};

export const spocEdit = {
  // list: "http://staging-cms.sworks.co.in/Application/Clientspoc/getuserdetails", //post city data All
  list: BASE_URL + 'user/user_details',
};
export const spocEditForm = {
  // list: "http://staging-cms.sworks.co.in/Application/Clientspoc/editUser", //active meber edit
  list: BASE_URL + 'user/editUserV1',
};

export const bulkFile = {
  // list: "http://staging-cms.sworks.co.in/Application/Clientspoc/editUser", //active meber edit
  data: BASE_URL + 'manageMembers/import-member-step1',
};

export const bulkFile2 = {
  data: BASE_URL + 'manageMembers/import-member-step2',
};

export const MemberAdd = {
  add: BASE_URL + 'user/member_data', //Post
};

export const LineChartData = {
  Line: BASE_URL + 'user/dashboard_visitor', //Get line chart
};

export const Parking = {
  // data: "http://staging-cms.sworks.co.in/Application/Clientspoc/parkgraph", //Get line Parking
  data: BASE_URL + 'user/parkGraph_details',
};

export const Pending = {
  data: BASE_URL + 'user/pending_access_details',

}


export const Tocleting = {
  // data: "http://staging-cms.sworks.co.in/Application/Clientspoc/ticketgraph", //Get line Parking
  data: BASE_URL + 'user/ticket_graph',
};

export const BarchartData = {
  Bar: BASE_URL + 'user/member_list', //barchart
};
export const SeatBarData = {
  data: BASE_URL + 'user/flexiSeatListLight', //seat BArchart
};

export const SeatBarPieData = {
  data: BASE_URL + 'user/total_seats', //Pichartwala
};

export const PieData = {
  Url: BASE_URL + 'user/total_seats', //seat Piedata
};

export const VisitorUrl = {
  data: BASE_URL + 'user/visitor_list', //Get visitor
};

export const VisitorViews = {
  data: BASE_URL + 'user/visit_detail', //Get visitor VIEW DATA
};

export const seatBookingUrl = {
  // data: "http://staging-cms.sworks.co.in/Application/Apiapp/fetchnamelist", //Get Seat VIEW DATA
  data: BASE_URL + 'user/bulk_booking_flexi',
};
export const SeatMapingData = {
  // data: "http://staging-cms.sworks.co.in/Application/Apiapp/fetchnamelist", //Get Seat VIEW DATA
  data: BASE_URL + 'user/fetch_namelist',
};

export const SeatEdit = {
  // data: "http://staging-cms.sworks.co.in/Application/Apiapp/mapseatapi", //Get Seat VIEW DATA
  data: BASE_URL + 'user/mapSeat',
};

export const addMemberUrl = {
  // data: "http://staging-cms.sworks.co.in/Application/Apiapp/mapseatapi", //Get Seat VIEW DATA
  data: BASE_URL + 'user/addUserV1',
};

export const SeatListUrl = {
  data: BASE_URL + 'user/flexiSeatListLight', //Get Seat VIEW DATA
};

export const LocationListUrl = {
  data: BASE_URL + 'user/getseatfilters', //Get Seat VIEW DATA
};
export const SeatBlooking = {
  data: BASE_URL + 'user/seat_booking', //Get Seat VIEW DATA
};


export const SeatBookingKpi = {
  data: BASE_URL + 'user/flexi-seat-booking-kpi', //Get Seat VIEW DATA
};

export const SeatBookingGraph = {
  data: BASE_URL + 'user/flexi-seat-booking-graph', //Get Seat VIEW DATA
};

export const RoomBookingList = {
  data: BASE_URL_NEW + 'api/booking/list', //Get Seat VIEW DATA
};

export const GetList = {
  data: BASE_URL + 'user/filter_api', //RoomPhoneData or name from others
};

export const RoomUtilizaation = {
  data: BASE_URL + 'user/vms_dashboard', //Get Room Utilization DATA
};

// SUBMIT ENQUIRY FORM
export const SubmitEnquriyForm = {
  data: BASE_URL + 'productEnquiry', //To submit enquiry form
};

export const getProductList = {
  data: BASE_URL + 'productEnquiry/getProductIDs', //To submit enquiry form
};

// Department
export const getDepartmentOptionsUrl =
  BASE_URL + 'department/getDepartmentOption';

export const getDepartmentMasterList =
  BASE_URL + 'department/getDepartmentMasterList';

export const postDepartment = BASE_URL + 'department';
export const putDepartment = BASE_URL + 'department/updateDepartment';

export const getShiftTiming = BASE_URL + 'roster/shiftTiming';
export const getDepartmentUser = BASE_URL + 'roster/DepartmentUserData';
export const getComapnySeat = BASE_URL + 'roster/seatUserData';
export const postRoster = BASE_URL + 'roster/insertRosterDataArrayNEW';
export const checkSeatRoster = BASE_URL + 'roster/checkAvailableSeat';

export const SeatNumberByLocation = {
  // data: "http://staging-cms.sworks.co.in/Application/Apiapp/fetchnamelist", //Get Seat VIEW DATA
  data: BASE_URL + 'user/loc_seat_list',
};

// http://localhost:3007/api/v1/department/getDepartmentMasterListByUser/202/14246

export const getDepartmentMasterListByUser =
  BASE_URL + 'department/getDepartmentMasterListByUser';

export const spintlyDashApi = BASE_URL + 'user/accessSpintly';

export const flexiSeatCoordsUrl = {
  data: BASE_URL + 'user/flexiSeatCoords',
};

export const userAccessDetails = {

  data: BASE_URL + 'user/access_details', //post 

}

export const getSPOCLocation = {
  // data: "http://staging-cms.sworks.co.in/Application/Clientspoc/floorapi", //post city data All
  data: BASE_URL + 'basic-data/get-location-by-client?client=202',
};



export const addRevenue = {

  data: BASE_URL + 'tickets/create-service-request',

}

export const fileAttachment = {

  data: BASE_URL + 'zoho/add-attachments',
}

export const addInternetService = {
  data: BASE_URL + 'zoho/create-ticket'
}


